<template>
    <div class="rating">
        <div class="stars">
            <i class="fa fa-star" v-for="star in starsToShow" :class="star"/>
        </div>
        <template v-if="count && showTotal">
            <a href="#" @click.prevent="clickCallback" v-if="clickCallback" class="reviews-count">({{ count }})</a>
            <span v-else class="reviews-count">({{ count }})</span>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'rating',

        props: {
            value: Number,
            count: Number,
            stars: {
                type: Number,
                default() {
                    return 5;
                }
            },
            clickCallback: Function,
            showTotal: {
                type: Boolean,
                default() {
                    return true;
                },
            },
        },

        computed: {
            starsToShow() {
                let stars = Array(this.stars).fill('fa-star');

                stars = stars.map((star, index) => {
                    if ((index + 1) <= this.value) {
                        return star + ' selected';
                    } else if (this.value - index >= 0.5) {
                        return 'fa-star-half-o selected';
                    }
                    return star;
                });

                return stars;
            }
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    h1 {
        .rating {
            a.reviews-count {
                margin-top: 0!important;
            }
        }
    }

    .location-reviews-heading,
    .reservation-summary-details {
        .rating {
            .reviews-count {
                margin-top: -3px;
            }
        }
    }
</style>

<style lang="less" scoped rel="stylesheet/less">
    @import (reference) "~bootstrap/less/mixins/clearfix";

    .rating {
        color: #3d424f;
        font-size: 11px;
        font-weight: 400;
        .stars {
            .clearfix;
        }
        > * {
            display: inline-block;
            vertical-align: middle;
            white-space: nowrap;
        }
        a {
            color: #000000;
        }
        .fa-star {
            font-size: 1.4em;
            margin-right: .194805195em;
            color: #e1e3e6;
            float: left;
            &.selected {
                color: #edc933;
            }
        }
        a.reviews-count {
            margin-left: 5px;
            margin-top: -5px;
        }
    }
</style>
